const navLinks = ['About', 'Careers', 'Events', 'Products', 'Support']

export default navLinks;